<template>
  <div id="screen" class="ui center aligned basic segment" style="overflow:auto;display:flex;margin:0">
    <div class="ui center aligned container purple segment" style="display:inline-block;margin:auto">
      <h3 class="header">Login</h3>
      <LoginDialog/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import LoginDialog from '@/components/LoginDialog.vue'

export default {
  name: 'LoginView',
  components: {
    LoginDialog
  },
  mounted() {
    setTimeout(()=>{
      const e = document.querySelector('#purpleheader').animate({height:"130px"}, 500)
      e.onfinish = ()=>{
        document.querySelector('#purpleheader').style.height = "130px";
      };
    },0);
  }
}
</script>
